import { render, staticRenderFns } from "./FeeItemInfoForm.vue?vue&type=template&id=9f2e8b00&"
import script from "./FeeItemInfoForm.vue?vue&type=script&lang=js&"
export * from "./FeeItemInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports